import { render } from "./Products.vue?vue&type=template&id=34fe1760&ts=true&lang=pug"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lauriel/gitRepos_work/hero/hero_web_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__